<template>
  <HelloWorld />
</template>

<script>
import HelloWorld from './components/homePage.vue';

export default {
  name: 'App',
  components: {
    HelloWorld,
  },
};
</script>

<style>
:root {
  --color-primary: #002b95;
}
body {
  margin: 0;
}
#app {
  font-family: Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
